/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Save_Overwrite_ButtonInputs */



/**
* | output |
* | --- |
* | "Save & Overwrite" |
*
* @param {Explorer_Info_Save_Overwrite_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_save_overwrite_button = /** @type {((inputs?: Explorer_Info_Save_Overwrite_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Save_Overwrite_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer et ecraser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern & Überschreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva e sovrascrivi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить и перезаписать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar y sobrescribir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存并覆盖")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存して上書き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहेजें और ओवरराइट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar e sobrescrever")
	return /** @type {LocalizedString} */ ("Save & Overwrite")
});